import React, { useEffect, useState } from 'react'
import { InputContainer, InputFormContainer, InputOutletContainer, InputSection, MobileTableContainer, WideTableContainer } from '../styles/Container.styled'
import { InputFormHeading, InputMainHeadingContainer } from '../styles/Input.styled'
import { MDBDataTable } from 'mdbreact';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../layout/Loader';
import { clearErrors, deleteHolding, getHoldings, reset } from '../../features/footprint/holdingSlice';
import { AddMainRecordButton, StyledLink } from '../styles/Button.styled';
import { InputForm } from '../styles/Form.styled';
import { IHolding } from '../../features/footprint/holdingSlice.interfaces';

type Props = {}

type IHoldingListWideData = {
    columns: {
        label: string,
        field: string,
        sort: string
    }[],
    rows: {
        reference: string,
        region: string,
        systemDescription: string,
        actions: React.ReactNode
    }[]
}

type IHoldingListMobileData = {
    columns: {
        label: string,
        field: string,
        sort: string
    }[],
    rows: {
        reference: string,
        region: string,
        actions: React.ReactNode
    }[]
}



const HoldingsList = (props: Props) => {

    const [selectedHoldingForDelete, setSelectedHoldingForDelete] = useState("");
    const [pulledData, setPulledData] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const { id } = useParams();

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const { loading, errors, holdings, isDeleted, paginationMetaData } = useAppSelector(state => state.holding)
    const { user } = useAppSelector(state => state.auth)
    const { users } = useAppSelector(state => state.user)

    useEffect(() => {
        if (!pulledData) {
            dispatch(getHoldings({ userProfileId: id ?? "", PageNumber: currentPage }));
            console.log(id)
            setPulledData(true);
        }

        if (isDeleted) {
            toast.dismiss();
            toast.success("Holding deleted successfully");
            dispatch(reset())
        }

        if (paginationMetaData) {
            setCurrentPage(paginationMetaData.currentPage)
        }

        if (errors) {
            toast.error(String(errors))
            dispatch(clearErrors)
        }

    }, [dispatch, errors, id, isDeleted, pulledData, paginationMetaData])

    const handlerNextPage = () => {
        if (paginationMetaData && (paginationMetaData?.currentPage < paginationMetaData?.totalPages)) {
            toast.dismiss();
            toast.info("Retrieving information...");
            dispatch(getHoldings({ userProfileId: id ?? "", PageNumber: currentPage + 1 }))
        }
    }

    const handlerPrevPage = () => {
        if (paginationMetaData && (paginationMetaData?.currentPage > 1)) {
            toast.dismiss();
            toast.info("Retrieving information...");
            dispatch(getHoldings({ userProfileId: id ?? "", PageNumber: currentPage - 1 }))
        }
    }

    const Actions = (props: { element: IHolding }) => {
        return (
            <>
                <div className="dropdown">
                    <button className="btn btn-secondary" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="fa-solid fa-ellipsis"></i>
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li>
                            <StyledLink to={`footprint/new/${props.element.id}`} className="ml-2 py-1 px-1">
                                <i className="fa-solid fa-plus mx-2 my-2" style={{ color: "#000" }}></i>Create Footprint
                            </StyledLink>
                        </li>
                        <li>
                            <StyledLink to={`/holding/${props.element.id}`} className="py-1 px-1 ml-2">
                                <i className="fa-solid fa-pen-to-square mx-2 my-2" style={{ color: "#000" }}></i>Edit Holding
                            </StyledLink>
                        </li>
                        <li>
                            <StyledLink to={`/holdings/footprints/${props.element.id}`} className="py-1 px-1 ml-2">
                                <i className="fa-solid fa-list mx-2 my-2" style={{ color: "#000" }}></i>Footprints
                            </StyledLink>
                        </li>
                        <li>
                            <StyledLink to={"#"} onClick={() => updateSelectedHoldingForDelete(props.element.id)} className="py-1 px-1 ml-2 border-none cursor-pointer" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                                <i className="fa-solid fa-box-archive mx-2 my-2" style={{ color: "crimson" }}></i> Archive Holding
                            </StyledLink>
                        </li>
                    </ul>
                </div>
            </>
        )
    }

    const setWideHoldings = () => {
        const data: IHoldingListWideData = {
            columns: [
                {
                    label: 'Reference',
                    field: 'reference',
                    sort: 'asc'
                },
                {
                    label: 'Region',
                    field: 'region',
                    sort: 'asc'
                },
                {
                    label: 'Holding Description',
                    field: 'systemDescription',
                    sort: 'asc'
                },
                {
                    label: 'Actions',
                    field: 'actions',
                    sort: 'asc'
                }

            ],
            rows: []
        }

        holdings && holdings.forEach(element => {
            data.rows.push({
                reference: element.reference,
                region: element.region,
                systemDescription: element.systemDescription,
                actions: <Actions element={element} />
            })
        });

        return data;
    }

    const setMobileHoldings = () => {
        const data: IHoldingListMobileData = {
            columns: [
                {
                    label: 'Reference',
                    field: 'reference',
                    sort: 'asc'
                },
                {
                    label: 'Region',
                    field: 'region',
                    sort: 'asc'
                },
                {
                    label: 'Actions',
                    field: 'actions',
                    sort: 'asc'
                }

            ],
            rows: []
        }

        holdings && holdings.forEach(element => {
            data.rows.push({
                reference: element.reference,
                region: element.region,
                actions: <Actions element={element} />
            })
        });

        return data;
    }

    const updateSelectedHoldingForDelete = (id: string) => {
        setSelectedHoldingForDelete(id);
    }

    const deleteSelectedHolding = () => {
        if (selectedHoldingForDelete !== "") {
            toast.info("Deleting holding...")
            dispatch(deleteHolding({ id: selectedHoldingForDelete }))
        }
    }

    return (
        <>
            <InputContainer>
                <InputMainHeadingContainer><h1>Thoroughbred Carbon Calculator</h1></InputMainHeadingContainer>
                <InputFormContainer>
                    <InputFormHeading>Holdings List {id && `- ${users?.filter(element => element.id === id)[0].email}`}</InputFormHeading>

                    <InputForm>
                        <AddMainRecordButton src='/icons/plus.png' alt='Add main record' onClick={() => navigate("/holding/new")} />

                        <div className='my-3'>
                            {loading ? <Loader /> : (
                                <>
                                    <WideTableContainer>
                                        <MDBDataTable
                                            data={setWideHoldings()}
                                            borderless
                                            hover
                                            noBottomColumns
                                            striped
                                            displayEntries={false}
                                            paging={false}
                                        />
                                    </WideTableContainer>
                                    <MobileTableContainer>
                                        <MDBDataTable
                                            data={setMobileHoldings()}
                                            borderless
                                            hover
                                            noBottomColumns
                                            striped
                                            displayEntries={false}
                                            paging={false}
                                        />
                                    </MobileTableContainer>
                                </>
                            )}
                        </div>
                    </InputForm>

                    {paginationMetaData && (
                        <>
                            <button className='nav-btn back-btn' disabled={paginationMetaData.currentPage === 1} onClick={handlerPrevPage}>Back</button>
                            <div className='pagination-info'>
                                <div>
                                    <div>{paginationMetaData.currentPage} / {paginationMetaData.totalPages}</div>
                                </div>
                            </div>
                            <button className='nav-btn next-btn' disabled={paginationMetaData.currentPage === paginationMetaData.totalPages} onClick={handlerNextPage}>Next</button>
                        </>
                    )}

                </InputFormContainer>
            </InputContainer>
            <div className="modal fade" id="exampleModalCenter" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLongTitle">Are you sure?</h5>
                            <button type="button" className="btn btn-secondary close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>This action <strong>CANNOT</strong> be undone. This would permanently archive the holding.</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Back</button>
                            <button type="button" className="btn btn-danger" onClick={deleteSelectedHolding} data-bs-dismiss="modal">Yes, Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HoldingsList